import { useEffect, useState } from "react";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Row, Col, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAllCompanies } from "../../redux/actions/mainAction";

import noitem from "../../images/noitem.gif";

const { confirm } = Modal;

const CompaniesTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { GlobalResponse } = useSelector((state) => state);
  const { MainResponse } = useSelector((state) => state);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    getCompanies(page);
  }, [GlobalResponse.triggeranyevent, page]);

  const getCompanies = async (page) => {
    try {
      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/get-companies/?page=${page}`,
        {
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();
      dispatch(setAllCompanies(result.companies));
      setTotalPages(result.totalPages);
    } catch (error) {}
  };

  const showDeleteConfirm = (companyName, _id, employeeCount) => {
    console.log(employeeCount);
    if (employeeCount < 1) {
      confirm({
        centered: "centered",
        title: companyName,
        icon: <ExclamationCircleFilled />,
        content: "Şirkəti silmək istədiyinizdən əminsiniz?",
        okText: "Sil",
        okType: "danger",
        cancelText: "İmtina Et",
        onOk() {
          deleteCompany(_id);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } else {
      confirm({
        centered: "centered",
        title: companyName + " silinə bilməz!",
        icon: <ExclamationCircleFilled />,
        content:
          "Bu şirkəti silmək üçün əvvəlcə şirkətdə çalışan əməkdaşları silmək lazımdır!",
        okText: "Oldu",
        okType: "danger",
        cancelText: "Əməkdaşlar",
        onOk() {},
        onCancel() {
          navigate("/employees");
        },
      });
    }
  };

  const deleteCompany = async (_id) => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/company/${_id}`,
      {
        method: "delete",
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
        "Content-Type": "application/json",
      }
    );
    result = await result.json();
    console.log(result);
    if (result) {
      getCompanies();
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      {MainResponse.allCompany.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Şirkətin Adı</th>
              <th>Şirkət Sektoru</th>
              <th>Əməkdaş Sayı</th>
              <th>Əməliyyat</th>
            </tr>
          </thead>
          {MainResponse.allCompany.map((company, index) => (
            <tbody key={company._id}>
              <tr>
                <td>{company._id}</td>
                <td>{company.companyName}</td>
                <td>{company.companyIndustry}</td>
                <td>{company.employeeCount}</td>

                <td>
                  <Link
                    state={{ id: company._id }}
                    className="btn"
                    to="/companyedit"
                  >
                    {<BiEdit />}
                  </Link>

                  <Link
                    onClick={() =>
                      showDeleteConfirm(
                        company.companyName,
                        company._id,
                        company.employeeCount
                      )
                    }
                    className="btn-del"
                  >
                    {<AiFillDelete />}
                  </Link>
                </td>
              </tr>
            </tbody>
          ))}
        </table>
      ) : (
        <div className="no-item">
          <Row>
            <Col span={24}>
              <div className="no-item">
                <img style={{ width: "342px" }} src={noitem} alt="noitem" />
              </div>
            </Col>
          </Row>
        </div>
      )}

      {totalPages > 0 && (
        <div className="pagination">
          <button
            disabled={page === 1}
            onClick={() => handlePageChange(page - 1)}
          >
            Əvvəlki
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              className={page === index + 1 ? "active" : ""}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button
            disabled={page === totalPages}
            onClick={() => handlePageChange(page + 1)}
          >
            Növbəti
          </button>
        </div>
      )}
    </>
  );
};

export default CompaniesTable;
